// ============================================================================
// JAMB Learn Content — Literature
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_LITERATURE_LEARN_SS1 } from '../../waec/learn/ss1/literature';
import { WAEC_LITERATURE_LEARN_SS2 } from '../../waec/learn/ss2/literature';
import { WAEC_LITERATURE_LEARN_SS3 } from '../../waec/learn/ss3/literature';

export const JAMB_LEARN_LITERATURE = [
  ...WAEC_LITERATURE_LEARN_SS1,
  ...WAEC_LITERATURE_LEARN_SS2,
  ...WAEC_LITERATURE_LEARN_SS3,
];
